import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Technicians from "@/pages/Technicians";
import TechnicianDocuments from "@/pages/TechnicianDocuments";
import Orders from "@/pages/Orders";
import OrderNew from "@/pages/OrderNew";
import OrderDetail from "@/pages/OrderDetail";
import InspectionsList from "@/pages/InspectionsList";
import InspectionDetail from "@/pages/InspectionDetail";
import Supervision from "@/pages/Supervision";
import MapPage from "@/pages/MapPage";
import MaintenancePlans from "@/pages/MaintenancePlans";
import ClientPortal from "@/pages/ClientPortal";
import Agenda from "@/pages/Agenda";
import AdminUsers from "@/pages/AdminUsers";
import MisContratos from "@/pages/MisContratos";
import MiComision from "@/pages/MiComision";
import FinancieroGeneral from "@/pages/FinancieroGeneral";
import ServiciosDisenoGeneral from "@/pages/ServiciosDisenoGeneral";
import Topbar from "@/components/Topbar";
import Dashboard from "@/pages/Dashboard";

function DashboardRouter() {
    const { user } = useAuth();
    if (user?.role === "cliente") return <ClientPortal />;
    return <Dashboard />;
}

function ProtectedShell({ children }) {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Cargando…</div>;
    if (!user) return <Navigate to="/login" replace />;
    return (<><Topbar />{children}</>);
}

function AppRouter() {
    const loc = useLocation();
    if (loc.hash?.includes("session_id=")) return <AuthCallback />;
    return (
        <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<ProtectedShell><DashboardRouter /></ProtectedShell>} />
            <Route path="/agenda" element={<ProtectedShell><Agenda /></ProtectedShell>} />
            <Route path="/clients" element={<ProtectedShell><Clients /></ProtectedShell>} />
            <Route path="/clients/:id" element={<ProtectedShell><ClientDetail /></ProtectedShell>} />
            <Route path="/technicians" element={<ProtectedShell><Technicians /></ProtectedShell>} />
            <Route path="/technicians/:cedula/documents" element={<ProtectedShell><TechnicianDocuments /></ProtectedShell>} />
            <Route path="/orders" element={<ProtectedShell><Orders /></ProtectedShell>} />
            <Route path="/orders/new" element={<ProtectedShell><OrderNew /></ProtectedShell>} />
            <Route path="/orders/:id" element={<ProtectedShell><OrderDetail /></ProtectedShell>} />
            <Route path="/inspections" element={<ProtectedShell><InspectionsList /></ProtectedShell>} />
            <Route path="/inspections/:id" element={<ProtectedShell><InspectionDetail /></ProtectedShell>} />
            <Route path="/supervision" element={<ProtectedShell><Supervision /></ProtectedShell>} />
            <Route path="/map" element={<ProtectedShell><MapPage /></ProtectedShell>} />
            <Route path="/plans" element={<ProtectedShell><MaintenancePlans /></ProtectedShell>} />
            <Route path="/admin/users" element={<ProtectedShell><AdminUsers /></ProtectedShell>} />
            <Route path="/mis-contratos" element={<ProtectedShell><MisContratos /></ProtectedShell>} />
            <Route path="/mi-comision" element={<ProtectedShell><MiComision /></ProtectedShell>} />
            <Route path="/financiero" element={<ProtectedShell><FinancieroGeneral /></ProtectedShell>} />
            <Route path="/servicios-diseno" element={<ProtectedShell><ServiciosDisenoGeneral /></ProtectedShell>} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
